import { SVG, SVGProps } from './svg'

export function IconChartTreemap(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M3 4c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 0 1-1-1V4ZM13 4c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1h-6a1 1 0 0 1-1-1V4ZM13 16c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-6a1 1 0 0 1-1-1v-4Z" />
    </SVG>
  )
}
